module.exports = __webpack_public_path__ + "img/financiero.33d8d83d.png";